import api from "./apiUtility";

export const getExamDetails= async () => {
    try {
        const response = await api.get("/admin/exam-details");
        return response;

    } catch (error) {
        throw error
    }

}


export const getStudentInfo= async (examName,shift) => {
    try {
        const response = await api.get(`/api/enrollment-summary?examName=${examName}&shift=${shift}`);
        
        return response;

    } catch (error) {
        throw error
    }
}

export const getStudentCount= async (examName,shift) => {
    try {
        const response = await api.get(`student-counts-v4/${examName}/${shift}`);
        return response;

    } catch (error) {
        throw error
    }
}

export const getStudentCountV4 = getStudentCount;

export const getStudentDetails = async (examName, centerCode, shift) => {
    try {
        const response = await api.get(`students/${examName}/${centerCode}/${shift}`);
        return response;

    } catch (error) {
        throw error
    }
}

export const examStats= async (examName,shift) => {
    try {
        const response = await api.get(`/api/enrollment-summary?examName=${examName}&shift=${shift}`);
        return response;

    } catch (error) {
        throw error
    }
}
export const getAnalytics = async (examName,shift) =>{
    try{
        const response = await api.get(`student-counts-v4/${examName}/${shift}`);
        return response;
    }
    catch(error){
        console.log("analytics error")
        throw error
    }
}
export const updateCandidateStatus= async (payload) => {
    try {
        const response = await api.post("/admin-school/onboard-new-teacher", payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );
        return response;
    } catch (error) {
        throw error
    }
}